<mat-form-field appearance="outline" style=" width: 100%" [ngClass]="allClasses"
  [style]="customStyle">
  <input type="text" matInput [formControl]="searchCtrl" [matAutocomplete]="auto"
     (click)="showAllOptions()"
    [placeholder]="placeholder? placeholder : 'select' |translate" />

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWithFn" (optionSelected)="onSelect($event.option.value)">
    @for (item of filteredItems; track item) {
    <mat-option [value]="item">{{ displayName(item) }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
<div class="error">
    <app-error [control]="control" [type]="type"></app-error>
</div>
